import React, {useEffect, useState} from 'react';
import {useAuth} from "react-oidc-context";
import {CustomPromptsRepository} from "../../repositories/CustomPromptsRepository";
import {CustomPrompt} from "../../models/customprompt/CustomPrompt";
import {AuthHelpers, UserRole} from "../../Utils/AuthHelpers";
import {Box, Container, Paper, Typography} from "@mui/material";
import LoadingIndicator from "../../components/LoadingIndicator";
import {DataGrid} from "@mui/x-data-grid";

const CustomPromptList = () => {
    const auth = useAuth();
    const repo = new CustomPromptsRepository(auth);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [prompts, setPrompts] = useState<CustomPrompt[]>([]);
    
    useEffect(() => {
        if (!AuthHelpers.isUserInrole(auth, UserRole.SuperAdmin)) {
            return;
        }
        setIsLoading(true);
        getAllPrompts().catch(console.error);
    }, []);
    
    const getAllPrompts = async () => {
        const prompts = await repo.allPrompts()

        if (prompts) {
            setPrompts(prompts);
        }
        
        setIsLoading(false);
    }
    
    if (!AuthHelpers.isUserInrole(auth, UserRole.SuperAdmin)) {
        return <></>;
    }
    
    return <>
        <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
            <Paper elevation={3} sx={{ p: 3, bgcolor: "background.paper" }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <Typography variant="h5" sx={{ ml: 1 }} color="secondary">
                        Voorstellen
                    </Typography>
                </Box>
                <DataGrid
                    rows={prompts}
                    getRowId={(f: CustomPrompt) => f.uniqueId}
                    rowSelection={true}
                    columns={[
                        { field: "uniqueId", headerName: "Id" },
                        { field: "userId", headerName: "User Id" },
                        { field: "prompt", headerName: "Prompt", minWidth: 200 },
                        { field: "result", headerName: "Resultaat", minWidth: 200 },
                    ]}
                />
                <LoadingIndicator show={isLoading}/>
            </Paper>
        </Container>
    </>
}

export default CustomPromptList;